import React from 'react';

const MerrillEdgeDisclaimer = () => (
  <div className="disclaimer">
    By clicking this link, you acknowledge that you will be redirected to
    MerrillEdge.com. MerrillEdge.com is targeted at and intended to be viewed by
    persons located in the United States and Canada, and is governed by the
    terms of use and data protection notices linked to that site. Nothing
    contained on MerrillEdge.com constitutes an offer of goods and services to
    persons outside the United States or Canada, nor do any materials on the
    site establish a commitment by Merrill or any of its affiliates to make any
    financial product or service available to any person that visits that site.
  </div>
);

MerrillEdgeDisclaimer.propTypes = {};
MerrillEdgeDisclaimer.displayName = 'MerrillEdgeDisclaimer';

export default MerrillEdgeDisclaimer;
